import React from 'react'
import PropTypes from 'prop-types'
import { setColorTheme } from 'theme/utils/generic-helpers'

const testimonials = [
  {
    body: 'This conference changed the way I see designs and products, even how to build them.',
    author: {
      name: 'Jimmy Ritter',
      jobTitle: 'Web Developer',
      linkedIn:
        'https://www.linkedin.com/in/ritterjimmy?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAAAxgTmIBKgUcx3SQP6pXqMPOmefYL-E8rwM&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BzlLoBBSnREm7x9QA%2B9HgyQ%3D%3D',
      company: 'KPMG',
      imageUrl: '/images/profiles/jimmyritter.jpeg',
    },
  },
  {
    body: 'The growth I experienced as a designer after UXDX merely over a three day period is astonishing',
    author: {
      name: 'Sidharath Chhatsni',
      jobTitle: 'Senior Product Designer',
      linkedIn: 'https://www.linkedin.com/in/sidharathc/',
      company: 'Mark43',
      imageUrl: '/images/profiles/sidharath.jpeg',
    },
  },
  {
    body: "How do I sell my great ideas to colleagues who weren't there?",
    author: {
      name: 'Martin Gjesdal',
      jobTitle: 'Product Manager',
      linkedIn: 'https://www.linkedin.com/in/martingjesdal',
      company: 'Storebrand',
      imageUrl: '/images/profiles/martingjesdal.jpeg',
    },
  },
  {
    body: 'We looked at every UX conference in the world, but none had speakers of the same calibre as UXDX.',
    author: {
      name: 'Kevin Richardson',
      jobTitle: 'UX Team Lead',
      linkedIn: 'https://uk.linkedin.com/in/kevin-richardson-19924113',
      company: 'CEF',
      imageUrl: '/images/profiles/kevinrichardson.jpeg',
    },
  },
  {
    body: 'I know that what I have been pushing within our company is right and this year getting IT leadership to attend with me got the message across the them.',
    author: {
      name: 'Mick Brady',
      jobTitle: 'Principal Product Design Lead',
      linkedIn:
        'https://www.linkedin.com/in/mick-brady?miniProfileUrn=urn%3Ali%3Afs_miniProfile%3AACoAABMQIDsButEar1t36MKU0rN9sD2DczBAAH8&lipi=urn%3Ali%3Apage%3Ad_flagship3_search_srp_all%3BNofW6JWdSMydNxmSXtccIQ%3D%3D',
      company: 'Unum',
      imageUrl: '/images/profiles/mickbrady.jpeg',
    },
  },
  {
    body: 'Excellent opportunity to get an insight in great companies and how they work and succeed to build better products',
    author: {
      name: 'Sandra Siggelin',
      jobTitle: 'Team Manager',
      linkedIn: 'https://www.linkedin.com/in/sandra-siggelin',
      company: 'Swedbank',
      imageUrl: '/images/profiles/sandra.jpg',
    },
  },
  {
    body: 'A jam-packed conference with many amazing speakers, bursting with ideas to share.',
    author: {
      name: 'Jean Liu',
      jobTitle: 'Head of Product',
      linkedIn: 'https://www.linkedin.com/in/jeanliu1/',
      company: 'Altmetric',
      imageUrl: '/images/profiles/jeanliu.jpeg',
    },
  },
  {
    body: "If you are in product, you'd better be at UXDX! Get ready for a two-day knowledge rollercoaster!",
    author: {
      name: 'Nicky Rutten',
      jobTitle: 'UX/UI Architect',
      linkedIn: 'https://be.linkedin.com/in/nickyrutten',
      company: 'N digital studio',
      imageUrl: '/images/profiles/nickyrutten.jpeg',
    },
  },
  {
    body: 'The care that they put into the craft of the talks makes this conference so special',
    author: {
      name: 'Marijke Jorritsma',
      jobTitle: 'Design Manager',
      linkedIn: 'https://www.linkedin.com/in/marijke-jorritsma-06907450',
      company: 'NASA Propulsion Labs',
      imageUrl: '/images/profiles/marijke.jpeg',
    },
  },
  {
    body: 'Turbo powered learning',
    author: {
      name: 'Atte Hynninen',
      jobTitle: 'CPO',
      linkedIn: 'https://fi.linkedin.com/in/attehynninen',
      company: 'WordDive',
      imageUrl: '/images/profiles/atte.jpeg',
    },
  },
  {
    body: 'UXDX is one of the rare experience focused conferences that brings together cross-functional disciplines',
    author: {
      name: 'Cindy Chastain',
      jobTitle: 'SVP Global Customer Experience & Design',
      linkedIn: 'https://www.linkedin.com/in/cindychastain/',
      company: 'Mastercard',
      imageUrl: '/images/profiles/cindy.jpeg',
    },
  },
  {
    body: 'The speakers shared the best and worst of their experiences, giving the audience an insight into how to grow, fail fast and get ahead',
    author: {
      name: 'Amna Askari',
      jobTitle: 'Software Developer',
      linkedIn: 'https://www.linkedin.com/in/amnaaskari',
      company: 'Reach Plc',
      imageUrl: '/images/profiles/amnaaskari.jpeg',
    },
  },
]

const Testimonials = ({ conferenceLocation = 'uxdx' }) => {
  return (
    // <section
    //   className={setColorTheme(
    //     'bg-apac-800 bg-emea-800 bg-community-800 bg-uxdx-800 bg-usa-800',
    //     conferenceLocation,
    //   )}
    // >
    //   <div className="max-w-screen-xl mx-auto md:grid md:grid-cols-3 md:px-6 lg:px-8">
    //     <div
    //       className={`${setColorTheme(
    //         'md:border-apac-900 md:border-emea-900 md:border-community-900 md:border-uxdx-900 md:border-usa-900',
    //         conferenceLocation,
    //       )} py-12 px-4 sm:px-6 md:flex md:flex-col md:py-16 md:pl-0 md:pr-10 md:border-r lg:pr-8 lg:mr-8`}
    //     >
    //       <blockquote className="mt-8 md:flex-grow md:flex md:flex-col">
    //         <div className="relative text-lg leading-7 font-medium text-white md:flex-grow">
    //           <svg
    //             className={`${setColorTheme(
    //               'text-apac-600 text-emea-600 text-community-600 text-usa-600 text-uxdx-600 ',
    //               conferenceLocation,
    //             )} absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8`}
    //             fill="currentColor"
    //             viewBox="0 0 32 32"
    //           >
    //             <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
    //           </svg>
    //           <p className="relative">
    //             All product builders, all designers and all developers should be here - together.
    //           </p>
    //         </div>
    //         <footer className="mt-8">
    //           <div className="flex">
    //             <div className="flex-shrink-0 inline-flex rounded-full border-2 border-white h-13">
    //               <StaticImage
    //                 src="../images/profiles/deirdre.jpg"
    //                 className="h-12 w-12 rounded-full"
    //                 alt="Deirdre Ni Luasaigh - CEO, CultureArk"
    //               />
    //             </div>
    //             <div className="ml-4">
    //               <div className="text-base leading-6 font-medium text-white">Deirdre Ni Luasaigh</div>
    //               <div
    //                 className={`${setColorTheme(
    //                   'text-apac-200 text-emea-200 text-community-200 text-uxdx-200 text-usa-200',
    //                   conferenceLocation,
    //                 )} text-base leading-6 font-medium`}
    //               >
    //                 CEO, CultureArk
    //               </div>
    //             </div>
    //           </div>
    //         </footer>
    //       </blockquote>
    //     </div>
    //     <div
    //       className={`${setColorTheme(
    //         'md:border-apac-900 md:border-emea-900 md:border-community-900 md:border-uxdx-900 md:border-usa-900',
    //         conferenceLocation,
    //       )} py-12 px-4 sm:px-6 md:flex md:flex-col md:py-16 md:pr-10 md:border-r lg:pr-8 lg:mr-8`}
    //     >
    //       <blockquote className="mt-8 md:flex-grow md:flex md:flex-col">
    //         <div className="relative text-lg leading-7 font-medium text-white md:flex-grow">
    //           <svg
    //             className={`${setColorTheme(
    //               'text-apac-600 text-emea-600 text-community-600 text-uxdx-600 text-usa-600',
    //               conferenceLocation,
    //             )} absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8`}
    //             fill="currentColor"
    //             viewBox="0 0 32 32"
    //           >
    //             <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
    //           </svg>
    //           <p className="relative">
    //             Excellent opportunity to get an insight in great companies and how they work and succeed to
    //             build better products
    //           </p>
    //         </div>
    //         <footer className="mt-8">
    //           <div className="flex">
    //             <div className="flex-shrink-0 inline-flex rounded-full border-2 border-white h-13">
    //               <StaticImage
    //                 src="../images/profiles/sandra.jpg"
    //                 className="h-12 w-12 rounded-full"
    //                 alt="Sandra Siggelin - Team Manager UI, Swedbank"
    //               />
    //             </div>
    //             <div className="ml-4">
    //               <div className="text-base leading-6 font-medium text-white">Sandra Siggelin</div>
    //               <div
    //                 className={`${setColorTheme(
    //                   'text-apac-200 text-emea-200 text-community-200 text-uxdx-200 text-usa-200',
    //                   conferenceLocation,
    //                 )} text-base leading-6 font-medium`}
    //               >
    //                 Team Manager UI, Swedbank
    //               </div>
    //             </div>
    //           </div>
    //         </footer>
    //       </blockquote>
    //     </div>
    //     <div
    //       className={`${setColorTheme(
    //         'md:border-apac-900 md:border-emea-900 md:border-community-900 md:border-uxdx-900 md:border-usa-900',
    //         conferenceLocation,
    //       )} py-12 px-4 sm:px-6 md:flex md:flex-col md:py-16 md:pr-0 md:border-t-0`}
    //     >
    //       <blockquote className="mt-8 md:flex-grow md:flex md:flex-col">
    //         <div className="relative text-lg leading-7 font-medium text-white md:flex-grow">
    //           <svg
    //             className={`${setColorTheme(
    //               'text-apac-600 text-emea-600 text-community-600 text-uxdx-600 text-usa-600',
    //               conferenceLocation,
    //             )} absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8`}
    //             fill="currentColor"
    //             viewBox="0 0 32 32"
    //           >
    //             <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
    //           </svg>
    //           <p className="relative">2 days of inspiring talks with real actionable insights</p>
    //         </div>
    //         <footer className="mt-8">
    //           <div className="flex">
    //             <div className="flex-shrink-0 inline-flex rounded-full border-2 border-white h-13">
    //               <StaticImage
    //                 src="../images/profiles/frederic.jpg"
    //                 className="h-12 w-12 rounded-full"
    //                 alt="Frederic Bidot - Product Manager, Retail inMotion"
    //               />
    //             </div>
    //             <div className="ml-4">
    //               <div className="text-base leading-6 font-medium text-white">Frederic Bidot</div>
    //               <div
    //                 className={`${setColorTheme(
    //                   'text-apac-200 text-emea-200 text-community-200 text-uxdx-200 text-usa-200',
    //                   conferenceLocation,
    //                 )} text-base leading-6 font-medium`}
    //               >
    //                 Product Manager, Retail inMotion
    //               </div>
    //             </div>
    //           </div>
    //         </footer>
    //       </blockquote>
    //     </div>
    //   </div>
    // </section>
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-xl text-center">
          <h2
            className={`${setColorTheme(
              'text-apac-600 text-emea-600 text-community-600 text-usa-600 text-uxdx-600 ',
              conferenceLocation,
            )} text-lg font-semibold leading-8 tracking-tight`}
          >
            Testimonials
          </h2>
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Hear what people have to say about the conference
          </p>
        </div>
        <div className="mx-auto mt-16 flow-root max-w-2xl sm:mt-20 lg:mx-0 lg:max-w-none">
          <div className="-mt-8 sm:-mx-4 sm:columns-2 sm:text-[0] lg:columns-3">
            {testimonials.map((testimonial) => (
              <a
                key={testimonial.author.handle + testimonial.author.name}
                className="pt-8 sm:inline-block sm:w-full sm:px-4"
                target="_blank"
                href={testimonial.author.linkedIn}
                rel="noreferrer"
              >
                <figure className="rounded-2xl bg-gray-50 p-8 text-sm leading-6 hover:bg-white shadow-lg hover:scale-105 transition ease-in-out delay-150 mb-8 sm:mb-0">
                  <blockquote className="text-gray-900">
                    <p>{`“${testimonial.body}”`}</p>
                  </blockquote>
                  <figcaption className="mt-6 flex items-center gap-x-4">
                    {/* <img className="h-10 w-10 rounded-full bg-gray-50" src={testimonial.author.imageUrl} alt="" /> */}
                    <img
                      src={testimonial.author.imageUrl}
                      className="h-12 w-12 rounded-full"
                      alt={testimonial.author.name}
                    />
                    <div>
                      <div className="font-semibold text-gray-900">{testimonial.author.name}</div>
                      <div className="text-gray-600">{`${testimonial.author.jobTitle} at ${testimonial.author.company}`}</div>
                    </div>
                  </figcaption>
                </figure>
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

Testimonials.propTypes = {
  conferenceLocation: PropTypes.string,
}

export default Testimonials
